import styled, { css, keyframes } from 'styled-components'

export const Header = styled.header`
  display: none;
  justify-content: space-between;
  align-items: center;

  width: 100%;
  padding: 1rem;

  border-bottom: 4px solid var(--tabs-selected-color);
  color: var(--tabs-selected-color);

  @media (max-width: 767px) {
    display: flex;
  }

  h1 {
    font-size: 1.5rem;
    margin: 0;
  }
`

interface IToggle {
  toggle: boolean
}

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  } to {
    transform: rotate(-180deg);
  }
`

export const Toggle = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 2.625rem;
  height: 2.625rem;

  background: transparent;
  border: 0;

  cursor: pointer;

  svg {
    color: var(--tabs-selected-color);
    font-size: 2rem;

    ${(props: IToggle) =>
      props.toggle &&
      css`
        animation: ${rotate} 0.5s both;
      `}
  }
`
